import { render, staticRenderFns } from "./IndividualUnityBusiness.vue?vue&type=template&id=24be2e12"
import script from "./IndividualUnityBusiness.vue?vue&type=script&lang=ts"
export * from "./IndividualUnityBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports